'use client';

import { Button } from "@nextui-org/react";
import { FileJson, FileText, Database, FileCode, ArrowRight, GitCompare, Search } from "lucide-react";
import Link from "next/link";
import { usePathname } from "next/navigation";

export default function FormatterNav() {
    const pathname = usePathname();
    const currentFormatter = pathname.split('/')[1].split('-')[0];

    return (
        <div className="w-full flex flex-col items-center gap-6 mb-8">
            {/* Formatter Navigation */}
            <div className="flex flex-wrap gap-4 justify-center">
                <Link href="/json">
                    <Button
                        color={currentFormatter === 'json' ? 'primary' : 'default'}
                        variant={currentFormatter === 'json' ? 'solid' : 'flat'}
                        startContent={<FileJson className="w-5 h-5" />}
                        className={`min-w-[160px] h-12 px-6 shadow-sm hover:shadow-md transition-all duration-200 ${
                            currentFormatter === 'json' ? 'selected' : ''
                        }`}
                        radius="lg"
                        data-selected={currentFormatter === 'json'}
                    >
                        JSON Formatter
                    </Button>
                </Link>
                <Link href="/xml">
                    <Button
                        color={currentFormatter === 'xml' ? 'primary' : 'default'}
                        variant={currentFormatter === 'xml' ? 'solid' : 'flat'}
                        startContent={<FileCode className="w-5 h-5" />}
                        className={`min-w-[160px] h-12 px-6 shadow-sm hover:shadow-md transition-all duration-200 ${
                            currentFormatter === 'xml' ? 'selected' : ''
                        }`}
                        radius="lg"
                        data-selected={currentFormatter === 'xml'}
                    >
                        XML Formatter
                    </Button>
                </Link>
                <Link href="/yaml">
                    <Button
                        color={currentFormatter === 'yaml' ? 'primary' : 'default'}
                        variant={currentFormatter === 'yaml' ? 'solid' : 'flat'}
                        startContent={<FileText className="w-5 h-5" />}
                        className={`min-w-[160px] h-12 px-6 shadow-sm hover:shadow-md transition-all duration-200 ${
                            currentFormatter === 'yaml' ? 'selected' : ''
                        }`}
                        radius="lg"
                        data-selected={currentFormatter === 'yaml'}
                    >
                        YAML Formatter
                    </Button>
                </Link>
                <Link href="/sql">
                    <Button
                        color={currentFormatter === 'sql' ? 'primary' : 'default'}
                        variant={currentFormatter === 'sql' ? 'solid' : 'flat'}
                        startContent={<Database className="w-5 h-5" />}
                        className={`min-w-[160px] h-12 px-6 shadow-sm hover:shadow-md transition-all duration-200 ${
                            currentFormatter === 'sql' ? 'selected' : ''
                        }`}
                        radius="lg"
                        data-selected={currentFormatter === 'sql'}
                    >
                        SQL Formatter
                    </Button>
                </Link>
                <Link href="/diffchecker">
                    <Button
                        color={currentFormatter === 'diffchecker' ? 'primary' : 'default'}
                        variant={currentFormatter === 'diffchecker' ? 'solid' : 'flat'}
                        startContent={<GitCompare className="w-5 h-5" />}
                        className="min-w-[160px] h-12 px-6 shadow-sm hover:shadow-md transition-all duration-200"
                        radius="lg"
                        data-selected={currentFormatter === 'diffchecker'}
                    >
                        Diff Checker
                    </Button>
                </Link>
                <Link href="/jsonpath">
                    <Button
                        color={currentFormatter === 'jsonpath' ? 'primary' : 'default'}
                        variant={currentFormatter === 'jsonpath' ? 'solid' : 'flat'}
                        startContent={<Search className="w-5 h-5" />}
                        className="min-w-[160px] h-12 px-6 shadow-sm hover:shadow-md transition-all duration-200"
                        radius="lg"
                        data-selected={currentFormatter === 'jsonpath'}
                    >
                        JSONPath
                    </Button>
                </Link>
            </div>

            {/* Converter Navigation */}
            <div className="flex flex-col items-center gap-2">
                <p className="text-sm text-gray-500 dark:text-gray-400">Need to convert between formats?</p>
                <div className="flex flex-wrap gap-4 justify-center">
                    <Link href="/json/to/xml">
                        <Button
                            size="sm"
                            variant="light"
                            endContent={<ArrowRight className="w-4 h-4" />}
                            className="shadow-sm hover:shadow-md transition-all duration-200"
                            radius="lg"
                        >
                            JSON to XML
                        </Button>
                    </Link>
                    <Link href="/json/to/yaml">
                        <Button
                            size="sm"
                            variant="light"
                            endContent={<ArrowRight className="w-4 h-4" />}
                            className="shadow-sm hover:shadow-md transition-all duration-200"
                            radius="lg"
                        >
                            JSON to YAML
                        </Button>
                    </Link>
                    <Link href="/xml/to/json">
                        <Button
                            size="sm"
                            variant="light"
                            endContent={<ArrowRight className="w-4 h-4" />}
                            className="shadow-sm hover:shadow-md transition-all duration-200"
                            radius="lg"
                        >
                            XML to JSON
                        </Button>
                    </Link>
                    <Link href="/yaml/to/json">
                        <Button
                            size="sm"
                            variant="light"
                            endContent={<ArrowRight className="w-4 h-4" />}
                            className="shadow-sm hover:shadow-md transition-all duration-200"
                            radius="lg"
                        >
                            YAML to JSON
                        </Button>
                    </Link>
                    <Link href="/xml/to/yaml">
                        <Button
                            size="sm"
                            variant="light"
                            endContent={<ArrowRight className="w-4 h-4" />}
                            className="shadow-sm hover:shadow-md transition-all duration-200"
                            radius="lg"
                        >
                            XML to YAML
                        </Button>
                    </Link>
                    <Link href="/yaml/to/xml">
                        <Button
                            size="sm"
                            variant="light"
                            endContent={<ArrowRight className="w-4 h-4" />}
                            className="shadow-sm hover:shadow-md transition-all duration-200"
                            radius="lg"
                        >
                            YAML to XML
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    );
} 